/* ZERODVSN — premium layer: scroll reveals + hero petals */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveals(root) {
    var els = (root || document).querySelectorAll('.zd-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          var delay = parseInt(el.getAttribute('data-zd-delay') || '0', 10);
          setTimeout(function () { el.classList.add('is-in'); }, delay);
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px', threshold: 0.01 });
    els.forEach(function (el) { io.observe(el); });
  }

  function petals(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-zd-petals]').forEach(function (wrap) {
      if (wrap.childElementCount) return;
      var n = parseInt(wrap.getAttribute('data-zd-petals'), 10) || 14;
      if (window.innerWidth < 750) n = Math.ceil(n * 0.6);
      for (var i = 0; i < n; i++) {
        var p = document.createElement('i');
        var size = 6 + Math.random() * 7;
        p.style.left = (Math.random() * 100) + '%';
        p.style.width = size + 'px';
        p.style.height = (size * 0.8) + 'px';
        p.style.opacity = (0.35 + Math.random() * 0.5).toFixed(2);
        p.style.animationDuration = (9 + Math.random() * 10).toFixed(1) + 's';
        p.style.animationDelay = (-Math.random() * 18).toFixed(1) + 's';
        p.style.setProperty('--dx', (Math.random() * 160 - 40).toFixed(0) + 'px');
        wrap.appendChild(p);
      }
    });
  }

  // Keep the hero tucked exactly under the floating header, whatever its height.
  function headerSpace() {
    var h = document.querySelector('.header-wrapper');
    if (!h) return;
    var set = function () {
      document.documentElement.style.setProperty('--zd-header-space', h.offsetHeight + 'px');
    };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(h);
  }

  function init(root) { if (!root) headerSpace(); reveals(root); petals(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
